<template lang="html">
  <v-container fluid class="py-0">
    <v-row>
      <v-col class="col-3 py-0">
        <v-select
                flat solo
                v-model="form.operator"
                :items="operators"
                :prepend-icon="icon" color="blue"
                :disabled="operators.length <= 1"
        >
        </v-select>
      </v-col>
      <v-col class="pt-0">
        <v-text-field
                flat solo
                v-model="form.value"
                @keypress.enter="add()"
                :placeholder="label" :hint="hint" persistent-hint
                clearable color="blue"
        >
          <template v-slot:append-outer>
            <v-btn small text @click="add()" color="blue">
              <v-icon color="grey darken-2" class="mr-1">mdi-plus</v-icon> Add
            </v-btn>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {SEARCH_NS} from "@/store/modules/search/constants";
  import {mapActions} from "vuex";

  export default {
    data: () => ({
      form: {}
    }),
    props: {
      label: String,
      hint: String,
      icon: String,
      operators: {
        type: Array,
        default: () => ['=', '!=', '>', '>=', '<', '<=']
      }
    },
    created() {
      this.resetForm();
    },
    methods: {
      ...mapActions(SEARCH_NS, [
        'addFilter'
      ]),
      add() {
        this.addFilter({
          ...this.form,
          label: this.label,
          operators: [...this.operators],
          isExclude: false,
          isEnabled: true
        }).then(() => this.resetForm())
      },
      resetForm() {
        this.form = {
          operator: '=',
          value: ''
        }
      }
    }
  }
</script>
